import React from "react";

import { defaultLanguage } from "../config";

export const useSelectedLanguage = (): readonly [string] => {
  const [selectedLanguage, setSelectedLanguage] = React.useState<string>(defaultLanguage);
  // console.log("selectedLanguage:", selectedLanguage);

  const storedLang = localStorage.getItem("i18nextLng") as string;
  //* Change Language
  React.useEffect(() => {
    if (storedLang) {
      setSelectedLanguage(storedLang);
    }

    // Subscribe to storage event to sync across tabs/windows
    function handleStorageChange(event: StorageEvent): void {
      if (event.key === "i18nextLng" && event.newValue) {
        setSelectedLanguage(event.newValue);
      }
    }

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [storedLang]);

  return [selectedLanguage] as const;
};
